import React, { useEffect, useState, useRef, forwardRef } from 'react'
import { createPortal } from 'react-dom'
import cx from 'classnames'

import { gsap } from 'gsap'
import { CSSPlugin } from 'gsap/CSSPlugin'

import './index.scss'
import { usePortalState } from '@/context'

gsap.registerPlugin(CSSPlugin)

const portalRoot =
	typeof document !== `undefined` ? document.getElementById('portal') : null

const Portal: React.FC<any> = forwardRef(({ children, className }, ref) => {
	const [isBrowser, setIsBrowser] = useState(false)
	const { show, setShow } = usePortalState()
	const classes = cx(
		`fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-80 portal`,
		className
	)

	useEffect(() => {
		setIsBrowser(true)
	}, [])

	const portal = (
		<div ref={ref} className={classes}>
			{children}
		</div>
	)

	if (isBrowser) {
		return createPortal(portal, portalRoot)
	} else {
		return null
	}
})

export default Portal
